<!--
component: Loading
author: Ken Nakamura
description: APIからの情報取得およびローディング画面
-->
<template>
  <section>
    <v-container>
      <div class="loading-message">{{ loadingMessage }}</div>
      <v-spacer/>
      <div>
        <v-progress-circular
          v-show="loading"
          color="primary"
          indeterminate
          :size="50"
          :width="6"
        ></v-progress-circular>
      </div>
      <v-spacer />
      <div class="progress-message">{{ progressMessage }}</div>
    </v-container>
    <Dialog error :open="error" :ok="()=>error=false" to="/"
      title="ユーザ認証"
      body="ユーザが無効です。ログインし直して下さい。"
    />
    <Dialog error :open="unbrowsable" :ok="()=>{unbrowsable=false;$router.back();}"
      title="閲覧できません"
      :body="unbrowsableReason"
    />
  </section>
</template>

<script>
import constants from '../common/constants.js'
import { dbglog, authUrl, gaiyoURL, estateUrl, elvUrl, teihoUrl, gaiyoSummaryURL, elvSummaryUrl, teihoSummaryUrl } from '../common/utils.js'
import { apiUrl } from '../common/utils.js';
import Dialog from '../components/Dialog.vue'
import { CallApi, findKyoaiByUkeNo } from '../common/apiAccess.js'

export default {
  components: {
    Dialog,
  },
  data: () => {
    return {
      loading: true,
      loadingMessage: '検索中です...',
      progressMessage: 'しばらくお待ちください。',
      tokenDispired: false,
      error: false,
      unbrowsable: false,
      unbrowsableReason: '閲覧対象外です。',
    };
  },
  props: {
    action: {
      type: Number,
      default: () => 0
    },
    userName: {
      type: String,
      default: () => ''
    },
    password: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    token: {
      get() { return this.$store.state.token; },
      set(val) { this.$store.commit('setToken', val); }
    },
    unauthorized () {
      return !this.loading &&
       (this.token == undefined
       || this.token == null
       || this.token.length == 0
       || this.tokenDispired);
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val); }
    },
    mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    gaiyo: {
      get() { return this.$store.state.gaiyoData; },
      set(val) { this.$store.commit('setGaiyoData', val); }
    },
    gaiyoId: {
      get() { return this.$store.state.gaiyoId; },
      set(val) { this.$store.commit('setGaiyoId', val); }
    },
    kojiId () {
      return this.$store.state.kojiId;
    },
    ukeNo: {
      get() { return this.$store.state.ukeNo; },
      set(val) { this.$store.commit('setUkeNo', val); }
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    oyaban() {
      return this.$store.state.oyaban;
    },
    edaban() {
      return this.$store.state.edaban;
    },
    gaiyoList: {
      get() { return this.$store.state.gaiyoList; },
      set(val) { this.$store.commit('setGaiyoList', val); }
    },
    summaries: {
      get() { return this.$store.state.summaries; },
      set(val) { this.$store.commit('setSummaries', val); }
    },
    targetRout () {
      return constants.browseTargets[this.mode].view;
    },
  },
  mounted () {
    this.setMessage();
    this.doAction(this.action);
  },
  watch: {
    action () {
      this.doAction(this.action);
    }
  },
  methods: {
    setMessage () {
      let target = '';
      let act = '';
      target = constants.browseTargets[this.mode].data;

      switch (this.action) {
      case 0:
        act = '認証中';
        break;
      case 1:
        act = '受付番号検索中';
        break;
      case 2:
        act = '物件検索中';
        break;
      case 3:
        act = '住所検索中';
        break;
      case 4:
        act = '読み込み中';
        break;
      case 5:
        act = '番号検索中';
        break;
      }

      if (this.mode < 0) {
        this.loadingMessage = '';
      }
      else {
        this.loadingMessage = target + 'の' + act + 'です。';
      }
    },
    doAction (action) {
      switch (action) {
      case 0:
        // ユーザ認証（現在使われていない）
        this.authenticate(this.userName, this.password);
        break;
      case 1:
        // 受付番号検索
        if (this.mode == 1) { // 建築計画概要書
          this.searchByUkeNo(this.ukeNo, () => {
            dbglog(`Loading.doAction(1): searchByUkeNo(${this.ukeNo})`);
            if (this.gaiyoList == null || this.gaiyoList.length == 0) {
              //ToDo: not found message
              //alert('not found');
              //this.$router.back();
              this.loading = false;
              this.progressMessage = '見つかりません';
            }
            else if (this.gaiyoList.length == 1) {
              if (this.gaiyoList[0].kojiId === null || this.gaiyoList[0].kojiId.length == 0) {
                this.loadGaiyo(this.gaiyoList[0].daichoId, () => {
                  this.$router.replace(this.targetRout);
                });
              }
              else {
                var savDaichoId = this.gaiyoList[0].daichoId;
                this.searchByKojiId(this.gaiyoList[0].kojiId, () => {
                  if (this.gaiyoList.length == 1) {
                    this.loadGaiyo(this.gaiyoList[0].daichoId, () => {
                      this.$router.replace(this.targetRout);
                    });
                  }
                  else if (this.gaiyoList.length == 0) {
                    this.loadGaiyo(savDaichoId, () => {
                      this.$router.replace(this.targetRout);
                    });
                  }
                  else {
                    // 同一物件が複数あった場合
                    this.$router.replace('listest');
                  }
                });
              }
            }
            else {
              // ここには来ない？
              // 同一受付番号（未対応）
              this.$router.replace('resultlist');
            }
          });
        }
        else if (this.mode == 2) {
          this.message = this.ukeNo;
          this.searchByUkeNo(this.ukeNo, () => {
            if (this.gaiyoList === null || this.gaiyoList.length === undefined || this.gaiyoList.length == 0) {
              this.loading = false;
              this.progressMessage = '見つかりません';
            }
            else if (this.gaiyoList.length == 1) {
              this.loadGaiyo(this.gaiyoList[0].daichoId, () => {
                this.$router.replace(this.targetRout);
              });
            }
          });
        }
        else if (this.mode == 3 ) {
          this.message = this.ukeNo;
          this.searchByUkeNo(this.ukeNo, () => {
            if (this.gaiyoList === null || this.gaiyoList.length === undefined || this.gaiyoList.length == 0) {
              this.loading = false;
              this.progressMessage = '見つかりません';
            }
            else if (this.gaiyoList.length == 1) {
              this.loadGaiyo(this.gaiyoList[0].id, () => {
                this.$router.replace(this.targetRout);
              });
            }
            else {
              this.summaries = this.gaiyoList;
              this.$router.replace({ name: 'list-result', params: { listId: 5 }});
            }
          });
        }
        else if (this.mode == 4) {
          this.message = this.ukeNo;
          this.$router.replace({
            name: 'browse-sproad',
            params: { id: this.gaiyoId } 
          });
        }
        else if (this.mode == 5) {
          this.message = '許可番号: ' + this.ukeNo;
          this.$router.replace({
            name: 'browse-kaihatsu',
            params: { id: this.gaiyoId, target: this.$store.state.searchTargetType } 
          });
        }
        else if (this.mode == 7) {
          this.message = this.ukeNo;
          findKyoaiByUkeNo(this.ukeNo, (data) => {
            if (data === null || data.length === undefined || data.length == 0) {
              this.loading = false;
              this.progressMessage = "狭あい道路敷データが見つかりません";
            }
            else {
              const rec = data[0];
              this.$router.replace({
                name: 'browse-kyoai',
                params: { id: rec.id } 
              });
            }
          });
        }
        dbglog(`Loading.doAction(1): ukeNo=${this.ukeNo}`);
        break;
      case 2:
        if (this.kojiId == null || this.kojiId.length == 0) {
          // 概要書閲覧
          dbglog(`Loading.mounted: before loadGaiyo(${this.gaiyoId})`);
          this.loadGaiyo(this.gaiyoId, () => {
            dbglog(`Loading.mounted: loadGaiyo(${this.gaiyoId})`);
            this.$router.replace(this.targetRout);
          })
          return;
        }
        // 工事ID検索
        this.searchByKojiId(this.kojiId, () => {
          dbglog(`Loading.mounted: searchByKojiId(${this.kojiId})`);
          if (this.gaiyoList == null || this.gaiyoList.length == 0) {
            //alert('not found');
            this.unbrowsableReason = '概要書が見つかりません。';
            this.unbrowsable = true;
            //this.$router.back();
          }
          else if (this.gaiyoList.length == 1) {
            this.loadGaiyo(this.gaiyoList[0].daichoId, () => {
              this.$router.replace(this.targetRout);
            });
          }
          else {
            //this.$store.commit('setListId', 2);
            //this.$router.replace({ name: 'list', params: { listId: 2 }});
            this.$router.replace({ name: 'listest', params: { listId: 2 }});
          }        
        });
        break;
      case 3:
        // 住所検索
        this.searchByAddress(this.wardCode, this.townName, this.oyaban, this.edaban, () => {
          dbglog(`Loading.mounted: searchByAddress => ${this.summaries}`);
          //this.$store.commit('setListId', 1);
          this.$router.replace({ name: 'list-result', params: { listId: 1 }});
        });
        break;
      case 4:
        // 概要書閲覧
        dbglog(`Loading.mounted: before loadGaiyo(${this.gaiyoId})`);
        this.loadGaiyo(this.gaiyoId, () => {
          dbglog(`Loading.mounted: loadGaiyo(${this.gaiyoId})`);
          this.$router.replace(this.targetRout);
        });
        break;
      case 5:
        // 番号検索
        this.searchGaiyo(this.nendo, this.kuName, this.bango, () => {
          this.$router.replace(this.targetRout);
        });
        break;
      }
    },
    /**
     * action 0: ユーザ認証
     * @param {String} user ユーザ名
     * @param {function} password パスワード
     * @description 現在使われていない
     */
    authenticate (user, password) {
      const url = authUrl();
      const params = {
        username: user,
        password: password
      };
      dbglog(`Loading.authenticate(${user},${password}): ${url}`);

      fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
      })
      .then((response) => {
        dbglog('Loading.authenticate: response =>', 1);
        dbglog(response, 1);
        if (response.ok) {
          return response.json();
        }
        else {
          this.progressMessage = 'ユーザー認証に失敗しました。';
          this.loading = false;
          return response.status;
        }
      })
      .then((data) => {
        dbglog('Loading.authenticate: data =>', 1);
        dbglog(data, 1);
        if (data.token === undefined) {
          dbglog('token is undefined');
          this.progressMessage = 'ユーザー認証に失敗しました。';
          this.loading = false;
        }
        else {
          try {
            this.token = data.token;
            //this.$store.commit('setAuthority', data.authority);
            this.$store.commit('setUserInfo', data);
            if (data.appMode !== undefined && data.appMode > 0 && data.appMode < 0xff) {
              this.mode = data.appMode;
              this.$router.replace('method');
            }
            else {
              if (data.appMode !== undefined && data.appMode >= 0xff) {
                this.$store.commit('setMenuFlag', data.appMode & 0xff);
              }
              else {
                this.$store.commit('setMenuFlag', 0xff);
              }
              this.$router.replace('menu');
            }
          }
          catch (ex) {
            dbglog(ex);
            this.progressMessage = 'ユーザー認証に失敗しました。';
            this.loading = false;
          }
        }
      })
      .catch((err) => {
        dbglog(`Loading.authenticate: error => ${err}`);
        this.progressMessage = 'ユーザー認証サーバーに接続できません。';
        this.loading = false;
      });

    },
    /**
     * action 1: APIで受付番号により概要書データを検索する
     * @param {String} ukeNo 受付番号
     * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
     */
    searchByUkeNo (ukeNo, callback) {
      dbglog(`searchByUkeNo(${ukeNo})`);
      if (ukeNo == null || ukeNo.length == 0) {
        return;
      }

      let url;
      if (this.mode == 1) {
        url = gaiyoURL() + '?uke_no=' + ukeNo;
      }
      else if (this.mode == 2) {
        url = elvUrl() +  '?uke_no=' + ukeNo;
      }
      else if (this.mode == 3) {
        url = teihoUrl() + '?seiri_no=' + ukeNo;
      }
      else if (this.mode == 5) {
        url = apiUrl('Kaihatsu') +  '?uke_no=' + ukeNo;
      }
      else if (this.mode == 7) {
        url = apiUrl('Kyoai') +  '?uke_no=' + ukeNo;
      }
      else {
        this.loading = false;
        return;
      }
      dbglog(url);

      fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(data);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.tokenDispired = true;
          //this.$router.replace('login');
          this.error = true;
          return;
        }
        this.gaiyoList = data;
        callback();
      })
      .catch((err) => {
        dbglog(`Loading.searchByUkeNo(${ukeNo}): ${err}`);
      });
    },
    /**
     * action 2: APIにより工事IDで建築計画概要書を検索する
     * @param {String} kojiId 工事ID
     * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
     */
    searchByKojiId (kojiId, callback) {
      if (kojiId == null || kojiId.length == 0) {
        return;
      }

      let url;
      if (this.mode == 1) {
        url = estateUrl() + '?id=' + kojiId;
      }
      else {
        return;
      }
      dbglog(url);

      fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(data);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.tokenDispired = true;
          //this.$router.replace('login');
          this.error = true;
          return;
        }
        this.gaiyoList = data;
        callback();
      })
      .catch((err) => {
        dbglog(`Loading.searchByKojiId(${kojiId}): ${err}`);
      });
    },
    /**
     * action 3: APIにより住所で閲覧用データを検索する
     * @param {Number} ward 区コード
     * @param {String} town 町名
     * @param {Number} oya 地番親番
     * @param {Number} eda 地番枝番
     * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
     */
    searchByAddress (ward, town, oya, eda, callback) {
      const cond = `?ward=${ward}&town=${town}&oya=${oya}&eda=${eda}`;
      let url;
      if (this.mode == 1) {
        url = gaiyoSummaryURL();
      }
      else if (this.mode == 2) {
        url = elvSummaryUrl();
      }
      else if (this.mode == 3) {
        url = teihoSummaryUrl();
      }
      else if (this.mode == 7) {
        url = apiUrl('KyoaiSummary');
      }
      else {
        // 保険
        url = gaiyoSummaryURL();
      }
      url += cond;
      dbglog(url, -1);

      fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(`Loading.searchByAddress(${ward},${town},${oya},${eda}): ${data}`);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.tokenDispired = true;
          //this.$router.replace('login');
          this.error = true;
          return;
        }
        this.summaries = data;
        callback(data);
      })
      .catch((err) => {
        dbglog(`error Loading.searchByAddress(): ${err}`);
      });
    },
    /**
     * action 4: APIによりIDで特定の概要データを取得する
     * @param {String} id 閲覧対象のユニークID
     * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
     */
    loadGaiyo (id, callback) {
      this.gaiyoId = '';
      dbglog(`Loading.loadGaiyo(${id}) start`);
      let url = gaiyoURL() + '/' + id;
      if (this.mode == 2) {
        url = elvUrl() + '/' + id;
      }
      else if (this.mode == 3) {
        url = teihoUrl() + '/' + id;
      }
      else if (this.mode == 4) {
        url = apiUrl('SpecRoad') + '/' + id;
      }
      else if (this.mode == 5) {
        url = apiUrl('Kaihatsu') + '/' + id;
      }
      else if (this.mode == 6) {
        url = apiUrl('Takuzo') + '/' + id;
      }
      else if (this.mode == 7) {
        url = apiUrl('Kyoai') + '/' + id;
      }
      else if (this.mode == 8) {
        url = apiUrl('Kosaku') + '/' + id;
      }

      dbglog(`Loading.loadGaiyo(${id}) url=${url}`);
      this.loading = true;
      const authText = 'Bearer ' + this.token;

      fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: authText,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(`Loading.loadGaiyo(${id}) finish`);
        dbglog(data);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.tokenDispired = true;
          //this.$router.replace('/login');
          this.error = true;
          return;
        }

        try {
          this.gaiyoId = id;
          this.gaiyo = data;
          if (this.mode == 2 || this.mode == 3) {
            this.ukeNo = this.gaiyo.ukeNo;
            dbglog(data, 1);
          }
          else {           
            //this.ukeNo = this.gaiyo.gaiyoRec.ukE_NO;
            this.ukeNo = this.gaiyo.ukeNo;
          }
          if (this.mode == 1 && this.gaiyo.gaiyoRec && this.gaiyo.gaiyoRec.torisagE_KUBUN) {
            this.unbrowsableReason = '取下げにつき閲覧できません。';
            this.unbrowsable = true;
            return;
          }
          else if (this.mode == 1 && this.gaiyo.gaiyoRec && this.gaiyo.gaiyoRec.toriyamE_KUBUN) {
            this.unbrowsableReason = '取止めにつき閲覧できません。';
            this.unbrowsable = true;
            return;
          }
          else if (this.mode == 1 && this.gaiyo.gaiyoRec && (this.gaiyo.gaiyoRec.snS_KUBUN == 2)) {
            if (this.gaiyo.gaiyoRec.kknN_DAY < constants.keitsuDate) {
              this.unbrowsableReason = '指定された計画通知は、閲覧対象日以前のため閲覧できません。';
              this.unbrowsable = true;
              return;
            }
          }

          if (this.mode == 1) {
            // 閲覧ログの記録をAPI内で自動で行うとユーザIDが正しく取得できないため
            // クライアントからのリクエストに変更
            CallApi('RegistLog',
              { actionCode:101, actionName:'建築計画概要書閲覧',
                clientIp: this.$store.state.clientInfo.clientIp,
                userId: this.$store.state.userInfo.id,
                userName: this.$store.state.userInfo.userName,
                ukeNo:this.gaiyo.ukeNo, kknnNo:this.gaiyo.kknnNo },
              (data) => {
                if (data.errorCode) {
                  console.log(`regist log error (browse) ${data.errorCode}: ${data.message}`);
                }
                callback();
              });
          }
          else {
            callback();
          }
        }
        catch (err) {
          this.progressMessage = '概要書データの読み込みに失敗しました。';
          dbglog(`Loading.loadGaiyo: err ${err}`, -1);
        }
        this.loading = false;
      })
      .catch((err) => {
        dbglog(`Loading.loadGaiyo() error: ${err}`);
        this.gaiyo = null;
      });
    },
    /**
     * action 5: APIにより年度、区、番号に一致する概要データを検索する
     * @param {String} nendo 検索対象の年度文字列
     * @param {String} kuName 検索対象の区名称
     * @param {Number} bango 検索対象の受付番号（数値部分）
     * @param {function} callback 読み込みが完了した時に呼ばれるコールバック関数
     */
    searchGaiyo (nendo, kuName, bango, callback) {
      const url = apiUrl('GaiyoSummary') + `?nendo=${nendo}&ku=${kuName}&bango=${bango}`;
      this.loading = true;
      const authText = 'Bearer ' + this.token;
      fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: authText,
        },
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.tokenDispired = true;
          this.error = true;
          return;
        }
        this.summaries = data;
        callback(data);
      })
      .catch((err) => {
        dbglog(`Loading.searchGaiyo() error: ${err}`);
        this.gaiyo = null;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";

section {
  text-align: center;
}

.loading-message {
font-size: calc(1rem + 1.5vw);
font-weight: 400;
text-align: center;
color: navy;
}

.progress-message {
font-size: calc(1rem + 1.2vw);
font-weight: 200;
text-align: center;
color: navy;
}

</style>
